export const STUDY_CATEGORIES = [
  { id: 10, name: "Art & Architecture" },
  { id: 9, name: "Business & Technology" },
  { id: 6, name: "Film & TV" },
  { id: 13, name: "Food & Drink" },
  { id: 2, name: "Geography" },
  { id: 11, name: "Government & Politics" },
  { id: 1, name: "History" },
  { id: 3, name: "Literature & Language" },
  { id: 5, name: "Music" },
  { id: 7, name: "Religion & Philosophy" },
  { id: 4, name: "Science" },
  { id: 12, name: "Society & Lifestyle" },
  { id: 8, name: "Sports & Games" },
];